export default "__VITE_ASSET__zaJ7Zb6D__"